'use client';

import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Chatbot from '@/components/common/Chatbot';
import ProductsGallery from './components/ProductsGallery';
import ServicesShowcase from './components/ServicesShowcase';
import { analytics } from '@/lib/analytics';

export default function ProductsPage() {
  useEffect(() => {
    analytics?.trackPageView('/products');
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-24">
        {/* Page Header */}
        <div className="bg-gradient-to-br from-primary/5 to-secondary/5 py-12 border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
              Products & Services
            </h1>
            <p className="text-lg text-muted-foreground">
              Comprehensive consignment and logistics solutions for your business
            </p>
          </div>
        </div>

        <ProductsGallery />
        <ServicesShowcase />
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}